<div id="case-detailed-summary" class="container-fluid">
   <case-summary [idPrefix]="idPrefix"></case-summary>
</div>

